import React, { useState, useRef } from "react";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";
import { sendToLSQ } from "../services/LeadSquared";

// seo
import Seo from "../components/Seo";

// constants
import constant from "../constants";

// custom hooks
import { useCommonPageTracking } from "../hooks/usePageTracking";

// banner image
import bannerImg from "../images/doctor/banner.png";

// components
import Banner from "../components/Banner";
import TransformCard from "../components/ForDoctor/TransformCard";
import TechnologyCard from "../components/ForDoctor/TechnologyCard";
import EmpaneledDoctors from "../components/ForDoctor/EmpaneledDoctors";
import FormSection from "../components/ForDoctor/FormSection";
import ClinicalResearchComponent from "../components/Home/ClinicalResearch/ClinicalResearch";
import FaqComponent from "../components/Home/Faq/Faq";

const ForDoctorsPage = props => {
  const [loading, setLoading] = useState(false);
  const formSectionRef = useRef(null);

  // Use common page tracking hooks
  const { deviceType, operatingSystem } = useCommonPageTracking(
    "For Doctors Page",
    props.location.search
  );

  // Mixpanel Events -> Cta Click events
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "For Doctors Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
    });
  };

  // Mixpanel Events -> FAQ Click Events
  const handleMixpanelCTAFaq = (faqText, faqDesc) => {
    Mixpanel.track(MixpanelEvents.faq_clicked, {
      page_name: "For Doctors Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      faq_text: faqText,
      faq_desc: faqDesc,
      faq_location: "For Doctors Page - FAQ Clicked",
    });
  };

  // Scroll to form section
  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Handle form submission
  const handleFormSubmit = async formData => {
    setLoading(true);
    // leadSquared params
    let leadSquaredParams = {
      FirstName: formData.fullName,
      Phone: formData.mobileNumber,
      mx_Website_CTA: "for-doctors-page",
      mx_Latest_Source: "New Website",
      mx_Device_Mobile_Desktop: deviceType,
      mx_msc_Operating_System: operatingSystem,
    };

    await sendToLSQ(leadSquaredParams);
    setLoading(false);
  };

  return (
    <>
      <Seo
        title="For Doctors | Partner with Twin Health India"
        description="Move beyond symptom care with AI metabolic insights that help your patients reach remission and reduce medicines safely. Partner with Twin Health."
      />
      <Banner
        pageName="For Doctors"
        title="Partner with India’s Most Advanced Healthcare Partnership Program"
        description="Join a trusted network of doctors through Twin Health’s healthcare partnership in India, where AI Digital Twin™ technology helps improve metabolic health outcomes and supports long-term remission for diabetes, obesity, PMOS and hypertension."
        ctaText="Partner with Twin Health"
        ctaLink=""
        bannerImage={bannerImg}
        imageWidth="558px"
        imageHeight="566px"
        onCtaClick={() => {
          handleMixpanelCTA(
            "Partner with Twin Health",
            "For Doctors Page - Banner Section"
          );
          scrollToForm();
        }}
      />

      <TransformCard />

      <TechnologyCard />

      <EmpaneledDoctors
        maxDoctors={6}
        showLoadMore={true}
        onCtaClick={ctaText => {
          handleMixpanelCTA(ctaText, "For Doctors Page - Empaneled Doctors");
        }}
      />

      <ClinicalResearchComponent
        carouselData={constant.CLINICAL_RESEARCH_CARDS}
      />

      <FormSection
        ref={formSectionRef}
        onFormSubmit={handleFormSubmit}
        mixpanelPageName="For Doctors Page"
        loading={loading}
        deviceType={deviceType}
        operatingSystem={operatingSystem}
      />

      <FaqComponent
        title="Frequently Asked Questions"
        accordionPayload={constant.FOR_DOCTORS_PAGE_FAQ}
        onCtaClick={(faqText, faqDesc) =>
          handleMixpanelCTAFaq(faqText, faqDesc)
        }
      />
    </>
  );
};

export default ForDoctorsPage;
